import { handleActions } from "redux-actions";
import {
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_FILTERS_SUCCESS,
  FETCH_TABLE_SUCCESS,
  FETCH_REVENUE_CATEGORIES_SUCCESS,
  SET_FILTERS_LOADING,
  SET_UPDATES_LOADING,
  SET_FILTERS_DIRTY,
  SET_LOADING,
  UPDATE_CUSTOM_RANGE,
  UPDATE_DATES,
  FETCH_CHART_SUCCESS,
  UPDATE_FILTERS,
  UPDATE_VIEW_FILTER,
  RESET_DATA
} from "./remainingSessionsSagas";
import {
  getDateRanges,
  getRangeOptionsWithCustom,
  getSelectedRangeOptionWithCustom
} from "../../../utils/date-range-options";

export const initialState = {
  currentUser: {},
  isLoading: true,
  filtersLoading: {
    sales_packages: false,
    secondary_category: false,
    primary_categories: false
  },
  updatesLoading: false,
  filtersDirty: false,
  table: {},
  chartValues: [],
  filters: {
    membership_types: [],
    prospect_types: []
  },
  selectedFilters: {
    membership_types: [],
    prospect_types: [],
    remaining_sessions: ["1-2"],
    view: "Membership Type",
    group_by: {}
  },
  rangeOptions: [],
  selectedRangeOption: {}
};

const setIds = (arr) => {
  return arr?.map((item, idx) => {
    const itemId = item.replace(/\s/g, "") + idx;
    return { name: item, id: itemId };
  });
};

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [SET_FILTERS_LOADING]: (state, { payload: { filter, isLoading } }) => {
      const dependencies = {
        primary_categories: { secondary_categories: isLoading, sales_packages: isLoading },
        secondary_categories: { primary_categories: isLoading, sales_packages: isLoading },
        sales_packages: { primary_categories: isLoading, secondary_categories: isLoading }
      };
      return {
        ...state,
        filtersLoading: { ...state.filtersLoading, ...(dependencies[filter] || {}) }
      };
    },
    [SET_UPDATES_LOADING]: (state, action) => ({
      ...state,
      updatesLoading: action.payload
    }),
    [UPDATE_CUSTOM_RANGE]: (state, action) => ({
      ...state,
      selectedRangeOption: action.payload,
      selectedRequestDates: getDateRanges(
        state.currentUser.calendarEndDate,
        action.payload,
        state.currentUser.calendarStartDate
      ),
      filtersDirty: true
    }),
    [UPDATE_DATES]: (state, action) => ({
      ...state,
      selectedRequestDates: action.payload || state.selectedRequestDates,
      rangeOptions: getRangeOptionsWithCustom(state.rangeOptions, action),
      selectedRangeOption: getSelectedRangeOptionWithCustom(action),
      filtersDirty: true
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload,
      currencySymbol: action.payload.currencySymbol
    }),
    [FETCH_TABLE_SUCCESS]: (state, action) => ({
      ...state,
      table: action.payload
    }),
    [FETCH_CHART_SUCCESS]: (state, action) => ({
      ...state,
      chartValues: action.payload
    }),
    [FETCH_FILTERS_SUCCESS]: (state, action) => {
      const filtersData = {
        membership_types: setIds(action.payload.membership_types),
        prospect_types: setIds(action.payload.prospect_types),
        primary_categories: action.payload.primary_categories,
        secondary_categories: action.payload.secondary_categories,
        sales_packages: action.payload.sales_packages
      };
      return {
        ...state,
        filters: {
          ...action.payload,
          ...filtersData
        },
        selectedFilters: {
          ...initialState.selectedFilters,
          ...filtersData,
          group_by: action.payload?.group_by[0]
        }
      };
    },
    [FETCH_REVENUE_CATEGORIES_SUCCESS]: (state, action) => ({
      ...state,
      selectedFilters: {
        ...state.selectedFilters,
        ...action.payload
      }
    }),
    [UPDATE_FILTERS]: (state, { payload }) => ({
      ...state,
      filtersDirty: true,
      selectedFilters: { ...state.selectedFilters, ...payload }
    }),
    [UPDATE_VIEW_FILTER]: (state, { payload }) => {
      const resetSelectedFilters = {};
      if (payload === "Membership Type") {
        resetSelectedFilters.membership_types = state.filters.membership_types;
      } else {
        resetSelectedFilters.prospect_types = state.filters.prospect_types;
      }
      return {
        ...state,
        filtersDirty: true,
        selectedFilters: {
          ...state.selectedFilters,
          view: payload,
          ...resetSelectedFilters
        }
      };
    },
    [SET_FILTERS_DIRTY]: (state, action) => ({
      ...state,
      filtersDirty: action.payload
    }),
    [RESET_DATA]: () => ({
      ...initialState
    })
  },
  initialState
);
